import LoadLocalNavigation from "./LoadLocalNavigation";
import LoadBreadCrumb from "./LoadBreadCrumb";
import LoadSeoConsultantText from "./LoadSeoConsultantText";
import LoadSeoBottomLinks from "./LoadSeoBottomLinks";
import LoadSeoSidebarText from "./LoadSeoSidebarText";
import LoadSeoMetaBlock from "./LoadSeoMetaBlock";
import { SelectionState } from "@otto-ec/nexus-registry/selection";
import { NexusEventListener, otto } from "@otto-ec/global-resources/nexus";

export default class MultiFiltering {
  private static hasBeenInitialized = false;

  public static init() {
    if (MultiFiltering.hasBeenInitialized) {
      return;
    }
    MultiFiltering.hasBeenInitialized = true;

    MultiFiltering.onSelectionUpdated(LoadBreadCrumb.onLoadBreadcrumb);
    MultiFiltering.onSelectionUpdated(LoadLocalNavigation.onLoadLocalNavigation);
    MultiFiltering.onSelectionUpdated(LoadSeoConsultantText.onLoadSeoConsultantText);
    MultiFiltering.onSelectionUpdated(LoadSeoBottomLinks.onLoadSeoBottomLinks);
    MultiFiltering.onSelectionUpdated(LoadSeoSidebarText.onLoadNavSidebarText);
    MultiFiltering.onSelectionUpdated(LoadSeoMetaBlock.onLoadSeoMetaBlock);
  }

  private static onSelectionUpdated(callback: (data: { rule: string }) => void) {
    const listener: NexusEventListener<SelectionState> = (data) => {
      callback(data);
    };
    otto.selection.current.on(listener);
  }
}
